// src/components/Common/EmailAttachmentHandler.jsx
import { useEffect } from 'react';
import { attachEmailToInsight, getStoredInsightId, clearStoredInsightId } from '../../service/seo-insight-tracking.service';

const EmailAttachmentHandler = ({ user, isAuthenticated }) => {
  useEffect(() => {
    // Add a small delay to ensure auth state and storage are ready
    const timeoutId = setTimeout(() => {
      attachEmail();
    }, 500);

    return () => clearTimeout(timeoutId);
  }, [isAuthenticated, user]);

  const attachEmail = async () => {
    // Only proceed if user is authenticated and has an email
    if (!isAuthenticated || !user?.email) {
      console.log('ℹ️ User not authenticated or no email available');
      return;
    }

    // Get the stored insight ID from session storage
    const insightId = getStoredInsightId();
    
    if (!insightId) {
      console.log('ℹ️ No stored insight ID found');
      return;
    }

    try {
      console.log('🔗 Attaching email to insight ID:', insightId);
      console.log('📧 Email:', user.email);
      
      await attachEmailToInsight(insightId, user.email);
      
      console.log('✅ Email successfully attached to insight:', insightId);
      
      // Clear the stored ID after successful attachment
      clearStoredInsightId();
      
    } catch (error) {
      console.error('❌ Failed to attach email to insight:', error);
      console.error('Error details:', {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status
      });
      
      // If it's a 404 (insight not found), clear the ID
      if (error.response?.status === 404) {
        console.log('🗑️ Insight not found, clearing stored ID');
        clearStoredInsightId();
      }
      // For other errors, keep the ID so we can retry later
    }
  };

  // This component renders nothing
  return null;
};

export default EmailAttachmentHandler;